import React, {useEffect} from "react";
import DivDiagonal from "../../../components/DivDiagonal";
import {useSelector} from "react-redux";
import TradingPerformanceMonth from "../../../components/Charts/TradingPerformanceMonth";
import TradingPerfomanceDaily from "../../../components/Charts/TradingPerfomanceDaily";
import TradingPerfomanceAgroupDailyGeneral from "../../../components/Charts/TradingPerfomanceAgroupDailyGeneral";
import {useTranslation} from "react-i18next";
import {TradingWrapper, ContentArea} from "../../Trading/styles";
import {StrategyProductCard} from "../../Strategy/styles";
import {
    PerformanceStack,
    PerformancePageHeader,
    PerformanceWideCardColumn,
    PerformancePageInner,
    PerformanceTabsArea,
} from "./styles";

export default function PerformanceReport() {
    const { t } = useTranslation();
    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {isActiveSignature && (
                <TradingWrapper>
                    <DivDiagonal/>
                    <ContentArea>
                        <PerformancePageInner>
                            <PerformanceStack>
                                <PerformancePageHeader>
                                    <h1>
                                        <i className="fas fa-chart-line" aria-hidden="true"/>
                                        {' '}{t('performance_report_title')}
                                    </h1>
                                </PerformancePageHeader>

                                <PerformanceWideCardColumn>
                                    <StrategyProductCard>
                                        <PerformanceTabsArea>
                                            <ul
                                                className="nav nav-tabs nav-tabs-performance"
                                                id="performanceReportTab"
                                                role="tablist"
                                            >
                                                <li className="nav-item">
                                                    <a
                                                        className="nav-link active"
                                                        id="day-tab"
                                                        data-toggle="tab"
                                                        href="#performance-day"
                                                        role="tab"
                                                        aria-controls="performance-day"
                                                        aria-selected="true"
                                                    >
                                                        {t('performance_tab_day')}
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        className="nav-link"
                                                        id="month-tab"
                                                        data-toggle="tab"
                                                        href="#performance-month"
                                                        role="tab"
                                                        aria-controls="performance-month"
                                                        aria-selected="false"
                                                    >
                                                        {t('performance_tab_month')}
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        className="nav-link"
                                                        id="general-tab"
                                                        data-toggle="tab"
                                                        href="#performance-general"
                                                        role="tab"
                                                        aria-controls="performance-general"
                                                        aria-selected="false"
                                                    >
                                                        {t('performance_tab_general')}
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="performanceReportTabContent">
                                                <div
                                                    className="tab-pane fade show active"
                                                    id="performance-day"
                                                    role="tabpanel"
                                                    aria-labelledby="day-tab"
                                                >
                                                    <TradingPerfomanceDaily/>
                                                </div>
                                                <div
                                                    className="tab-pane fade"
                                                    id="performance-month"
                                                    role="tabpanel"
                                                    aria-labelledby="month-tab"
                                                >
                                                    <TradingPerformanceMonth/>
                                                </div>
                                                <div
                                                    className="tab-pane fade"
                                                    id="performance-general"
                                                    role="tabpanel"
                                                    aria-labelledby="general-tab"
                                                >
                                                    <TradingPerfomanceAgroupDailyGeneral/>
                                                </div>
                                            </div>
                                        </PerformanceTabsArea>
                                    </StrategyProductCard>
                                </PerformanceWideCardColumn>
                            </PerformanceStack>
                        </PerformancePageInner>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    );
}
